import Vue from "vue";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-bootstrap.css";

Vue.use(VueToast);

export default {
  data() {
    return {
      storeName: "",
      title: "",
      labelSubmit: this.$route.params.id ? "Actualizar" : "Crear",
      labelCancel: "Cancelar",
      filteredAttributes: [],
      data: {
        id: ""
      },
      parentUrlKey: "",
      parentStoreName: ""
    };
  },
  created() {
    const self = this;
    if (this.$route.params.id) {
      this.$store
        .dispatch(`${this.storeName}/show`, this.$route.params.id)
        .then(function(data) {
          for (let i in data) {
            if (
              self.data[i] !== undefined &&
              !self.filteredAttributes.includes(i)
            ) {
              self.data[i] = data[i];
            } else {
              if (
                self.filteredAttributes.includes(i) &&
                self[i] !== undefined
              ) {
                self[i] = data[i];
              }
            }
          }
          try {
            this.completedCreatedComponent();
          } catch (e) {}
        });
    }
  },
  methods: {
    buildRootUrl() {
      if (this.parentUrlKey && this.parentStoreName) {
        if (this.parentUrlKeyTwo && this.parentStoreNameTwo) {
          return (
            "/admin/" +
            this.parentStoreName.toLowerCase() +
            "/" +
            this.$route.params[this.parentUrlKey] +
            "/" +
            this.parentStoreNameTwo.toLowerCase() +
            "/" +
            this.$route.params[this.parentUrlKeyTwo] +
            "/" +
            this.storeName.toLowerCase()
          );
        } else {
          return (
            "/admin/" +
            this.parentStoreName.toLowerCase() +
            "/" +
            this.$route.params[this.parentUrlKey] +
            "/" +
            this.storeName.toLowerCase()
          );
        }
      } else {
        return "/admin/" + this.storeName.toLowerCase();
      }
    },
    async submit() {
      const self = this;
      let valid = await self.$refs.validator.validate();
      if (valid) {
        let saveUrl = this.$route.params.id
          ? `${this.storeName}/update`
          : `${this.storeName}/create`;
        self.$store
          .dispatch(saveUrl, self.data)
          .then(function() {
            self.$router.push(self.buildRootUrl());
          })
          .catch(function(response) {

            if (response.code === "ERROR_EMAIL_EXIST"){
              Vue.$toast.error("Ya existe un usuario con este email", { position: "top-right" });
              return;
            }

            for (const i in response.errors) {
              try {
                eval("self.$refs." + i + ".setErrors(response.errors[i]);");
              } catch (error) {
                //
              }
            }
          });
      }
    },
    formatDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("-");
      return `${year}-${month}-${day}`;
    },
    formatDateForSave(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${month}-${day}-${year}`;
    },
    completedCreatedComponent: Function
  }
};
